import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronRight, MapPin } from 'lucide-react';
import { adressenAPI } from '@/lib/api';
import AdresseFormular from '@/components/adressen/AdresseFormular';

/* Adressen nachtragen (Betreiber 23.10.2026): laufende Verträge und Mitgliedschaften ohne vollständige Adresse — so, wie
   der Rechnungslauf sie liest. Je Zeile direkt eintragen; gespeichert wird an Mitglied und laufenden Verträgen. */
export default function AdressenNachtragen() {
  const [daten, setDaten] = useState(null);
  const [offen, setOffen] = useState(false);
  const lade = useCallback(() => {
    adressenAPI.fehlend().then((r) => setDaten(r.data)).catch(() => setDaten(null));
  }, []);
  useEffect(() => { lade(); }, [lade]);
  if (!daten || daten.anzahl === 0) return null;
  const erledigt = (leadId) => setDaten((d) => ({ anzahl: d.anzahl - 1, zeilen: d.zeilen.filter((z) => z.lead_id !== leadId) }));
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50/60 dark:bg-amber-900/10 dark:border-amber-700/50" data-testid="adressen-nachtragen">
      <button type="button" onClick={() => setOffen((o) => !o)} className="w-full flex items-center gap-2 px-4 py-3 text-left text-sm">
        <MapPin className="w-4 h-4 text-amber-700 dark:text-amber-400" />
        <span className="font-semibold">Adresse fehlt bei {daten.anzahl} {daten.anzahl === 1 ? 'Mitglied' : 'Mitgliedern'}</span>
        <span className="text-xs text-muted-foreground hidden sm:inline">· für Rechnung und Vertrag nachtragen</span>
        <span className="ml-auto">{offen ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}</span>
      </button>
      {offen && (
        <ul className="divide-y divide-border/60 border-t border-border/60">
          {daten.zeilen.map((z) => {
            const start = { strasse: z.strasse || z.vorschlag?.address || '', plz: z.plz || '', ort: z.ort || z.vorschlag?.city || '' };
            return (
              <li key={z.lead_id} className="px-4 py-3 space-y-2" data-testid={`adresse-zeile-${z.lead_id}`}>
                <div className="flex items-baseline gap-2 flex-wrap text-sm">
                  <Link to={`/leads/${z.lead_id}`} className="font-medium hover:underline">{z.name || 'Ohne Name'}</Link>
                  <span className="text-xs text-muted-foreground">
                    {[z.mitgliedsnummer ? `Nr. ${z.mitgliedsnummer}` : null, z.vertragsnummer || 'ohne digitalen Vertrag', z.plan,
                      z.kind && z.eltern ? `Kind · ${z.eltern}` : null].filter(Boolean).join(' · ')}
                  </span>
                  {(z.vorschlag?.address || z.vorschlag?.city) && !z.strasse && <span className="text-xs text-muted-foreground">· Altangabe übernommen, bitte prüfen</span>}
                </div>
                <AdresseFormular kompakt leadId={z.lead_id} start={start} tid={`adresse-${z.lead_id}`} onGespeichert={() => erledigt(z.lead_id)} />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
